import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BrokerService } from '../core/broker/broker.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private msalService: MsalService,
    private http: HttpClient,
    private broker: BrokerService
  ) {}

  getGroupUserDetail(): Observable<any> {
    const groupId = this.broker.current().campaigns.agentsGroupId;
    // Quote Devil has no agent group yet; return an empty list rather than
    // calling Graph with a blank group id.
    if (!groupId) {
      return of({ value: [] });
    }

    const headers = new HttpHeaders().set('ConsistencyLevel', 'eventual');

    return this.http.get(
      `${environment.graphAPI.address}/${groupId}/members`,
      { headers }
    );
  }

  getUserDetail() {
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (
      !activeAccount &&
      this.msalService.instance.getAllAccounts().length > 0
    ) {
      activeAccount = this.msalService.instance.getAllAccounts()[0];
    }

    return activeAccount;
  }
}
